/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbRechercheExportGapRemplacementDto } from './FcbRechercheExportGapRemplacementDto';
import {
    FcbRechercheExportGapRemplacementDtoFromJSON,
    FcbRechercheExportGapRemplacementDtoFromJSONTyped,
    FcbRechercheExportGapRemplacementDtoToJSON,
} from './FcbRechercheExportGapRemplacementDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbRechercheExportGapRemplacementDtoPaginatedResults
 */
export interface FcbRechercheExportGapRemplacementDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbRechercheExportGapRemplacementDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbRechercheExportGapRemplacementDto>}
     * @memberof FcbRechercheExportGapRemplacementDtoPaginatedResults
     */
    results?: Array<FcbRechercheExportGapRemplacementDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbRechercheExportGapRemplacementDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbRechercheExportGapRemplacementDtoPaginatedResults interface.
 */
export function instanceOfFcbRechercheExportGapRemplacementDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbRechercheExportGapRemplacementDtoPaginatedResultsFromJSON(json: any): FcbRechercheExportGapRemplacementDtoPaginatedResults {
    return FcbRechercheExportGapRemplacementDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbRechercheExportGapRemplacementDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbRechercheExportGapRemplacementDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbRechercheExportGapRemplacementDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbRechercheExportGapRemplacementDtoPaginatedResultsToJSON(value?: FcbRechercheExportGapRemplacementDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbRechercheExportGapRemplacementDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

